import { CREATE_GROUP, UPDATE_GROUP, DELETE_GROUP } from "../graphql/mutation";
import { FETCH_ALL_GROUPS } from "../graphql/query";
import { executeMutation, executeQuery } from "utils/services/apiServices";
import { actionTypes, GroupInput, VideoGroupProps } from "./actionType";
import { showSnackbar } from "utils/snack_bar/store/action";

export const fetchVideoGroupsRequest = () => ({
  type: actionTypes.FETCH_VIDEO_GROUPS_REQUEST,
});

export const fetchVideoGroupsSuccess = (payload: VideoGroupProps[]) => ({
  type: actionTypes.FETCH_VIDEO_GROUPS_SUCCESS,
  payload,
});

export const fetchVideoGroupsFail = (payload: string) => ({
  type: actionTypes.FETCH_VIDEO_GROUPS_FAIL,
  payload,
});

export const fetchVideoGroups = () => {
  return async (dispatch: any) => {
    try {
      await dispatch(fetchVideoGroupsRequest());
      const response = await executeQuery(FETCH_ALL_GROUPS);
      const jsonData = response.data?.fetchAllGroups;
      if (jsonData?.error === null) {
        dispatch(fetchVideoGroupsSuccess(jsonData?.data.groups));
      } else {
        dispatch(fetchVideoGroupsFail(jsonData?.error.message));
      }
    } catch (error: any) {
      dispatch(fetchVideoGroupsFail("Failed to fetch Groups(s)"));
    }
  };
};

export const createVideoGroupSuccess = (payload: VideoGroupProps) => ({
  type: actionTypes.CREATE_VIDEO_GROUP_SUCCESS,
  payload,
});
export const createVideoGroupFail = (payload: string) => ({
  type: actionTypes.CREATE_VIDEO_GROUP_SUCCESS,
  payload,
});

export const createVideoGroup = (input: GroupInput) => {
  return async (dispatch: any) => {
    try {
      const input_data = {
        input: input,
      };
      const response = await executeMutation(CREATE_GROUP, input_data);
      const jsonData = response.data?.createGroup;
      if (jsonData?.error === null) {
        dispatch(createVideoGroupSuccess(jsonData?.data.group));
        dispatch(showSnackbar("Success! group created."));
      } else {
        dispatch(createVideoGroupFail(jsonData?.error.message));
        dispatch(
          showSnackbar(
            `Error :${
              jsonData?.error.message
                ? jsonData?.error.message
                : "Something went wrong"
            }`
          )
        );
      }
    } catch (error: any) {
      dispatch(createVideoGroupFail("Something went wrong, please try again"));
    }
  };
};

export const updateVideoGroupSuccess = (payload: VideoGroupProps) => ({
  type: actionTypes.UPDATE_VIDEO_GROUP_SUCCESS,
  payload,
});
export const updateVideoGroupFail = (payload: string) => ({
  type: actionTypes.UPDATE_VIDEO_GROUP_SUCCESS,
  payload,
});

export const updateVideoGroup = (
  input: GroupInput,
  group_id: string,
  folder_id: string
) => {
  return async (dispatch: any) => {
    try {
      const input_data = {
        input: input,
        group_id: group_id,
        folder_id: folder_id,
      };
      const response = await executeMutation(UPDATE_GROUP, input_data);
      const jsonData = response.data?.updateGroup;
      if (jsonData?.error === null) {
        dispatch(updateVideoGroupSuccess(jsonData?.data.group));
        dispatch(showSnackbar("Success! group updated."));
      } else {
        dispatch(updateVideoGroupFail(jsonData?.error.message));
        dispatch(
          showSnackbar(
            `Error :${
              jsonData?.error.message
                ? jsonData?.error.message
                : "Something went wrong"
            }`
          )
        );
      }
    } catch (error: any) {
      dispatch(updateVideoGroupFail("Something went wrong, try later"));
    }
  };
};

export const deleteVideoGroupSuccess = (payload: string) => ({
  type: actionTypes.DELETE_VIDEO_GROUP_SUCCESS,
  payload,
});
export const deleteVideoGroupFail = (payload: string) => ({
  type: actionTypes.DELETE_VIDEO_GROUP_FAILED,
  payload,
});

export const deleteVideoGroup = (group_id: string, folder_id: string) => {
  return async (dispatch: any) => {
    try {
      const input = {
        group_id: group_id,
        folder_id: folder_id,
      };
      const response = await executeMutation(DELETE_GROUP, input);
      const jsonData = response.data?.deleteGroup;
      if (jsonData?.error === null) {
        dispatch(deleteVideoGroupSuccess(group_id));
        dispatch(showSnackbar("Success! group deleted."));
      } else {
        dispatch(deleteVideoGroupFail(jsonData?.error.message));
        dispatch(
          showSnackbar(
            `Error :${
              jsonData?.error.message
                ? jsonData?.error.message
                : "Something went wrong"
            }`
          )
        );
      }
    } catch (error: any) {
      dispatch(deleteVideoGroupFail("Something went wrong, try later"));
    }
  };
};
